import { spawn } from "redux-saga/effects";
import { globalSaga } from "./features/globalSaga";

import { toolDisposalSaga } from "./toolDisposalRequests/toolDisposalSaga";

export function* rootSagas() {
  yield spawn(globalSaga);
  yield spawn(toolDisposalSaga);
}
